import { Box } from '@mui/material';

/**
 * Visually-hidden until focused. Lets keyboard users jump past the navbar
 * straight to the main content. WCAG 2.1 Bypass Blocks (2.4.1).
 */
const SkipToContent = () => (
    <Box
        component="a"
        href="#main-content"
        sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            p: 1.5,
            bgcolor: 'primary.main',
            color: 'common.white',
            fontWeight: 700,
            textDecoration: 'none',
            zIndex: (th) => th.zIndex.tooltip + 1,
            transform: 'translateY(-120%)',
            transition: 'transform 0.15s ease',
            borderBottomRightRadius: 4,
            '&:focus': {
                transform: 'translateY(0)',
                outline: '2px solid #fff',
                outlineOffset: 2,
            },
        }}
    >
        Skip to main content
    </Box>
);

export default SkipToContent;
